import { render } from "./KoruPercentField.vue?vue&type=template&id=6d30efd1&ts=true"
import script from "./KoruPercentField.vue?vue&type=script&lang=ts"
export * from "./KoruPercentField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__